import React from 'react'
import styles from './Services.module.scss'
import { motion } from "framer-motion"
import icon_1 from '../../image/Services/img_1.jpg'
import icon_2 from '../../image/Services/img_2.jpg'
import icon_3 from '../../image/Services/img_3.jpg'
import icon_4 from '../../image/Services/img_4.jpg'
import icon_5 from '../../image/Services/img_5.jpg'
import icon_6 from '../../image/Services/img_6.jpg'
import icon_7 from '../../image/Services/img_7.jpg'
import icon_8 from '../../image/Services/img_8.jpg'
import icon_9 from '../../image/Services/img_9.jpg'
import icon_10 from '../../image/Services/img_10.jpg'
import {phone} from '../../utils/data'

const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const cardAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3}
    } 
}

const Services = ({isOpen}) => {

    return (
        <motion.section 
            className={styles.main} 
            id='Services'
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.02, once: true}}
            >
                <div className={styles.box}>
                    <motion.h2 className={styles.title} variants={titleAnimation}>Выполним весь комплекс работ по монтажу и ремонту кровли для <span>вашего&nbsp;дома</span></motion.h2>
                    <motion.ul className={styles.list}>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                        <img className={styles.item_image}  src={icon_1} alt='илосос'/>
                            <div className={styles.box_info}>
                                <h3 className={styles.item_title}>Монтаж металлочерепицы</h3>
                                <a className={styles.item_button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>заказать <span className={styles.glare}></span></a>
                            </div>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                        <img className={styles.item_image}  src={icon_2} alt='илосос'/>
                            <div className={styles.box_info}>
                                <h3 className={styles.item_title}>Монтаж мягкой кровли</h3>
                                <a className={styles.item_button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>заказать <span className={styles.glare}></span></a>
                            </div>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                        <img className={styles.item_image}  src={icon_3} alt='илосос'/>
                            <div className={styles.box_info}>
                                <h3 className={styles.item_title}>Монтаж профнастила</h3>
                                <a className={styles.item_button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>заказать <span className={styles.glare}></span></a>
                            </div>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                        <img className={styles.item_image}  src={icon_4} alt='илосос'/>
                            <div className={styles.box_info}>
                                <h3 className={styles.item_title}>Монтаж ондулина</h3>
                                <a className={styles.item_button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>заказать <span className={styles.glare}></span></a>
                            </div>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                        <img className={styles.item_image}  src={icon_5} alt='илосос'/>
                            <div className={styles.box_info}>
                                <h3 className={styles.item_title}>Монтаж обрешётки</h3>
                                <a className={styles.item_button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>заказать <span className={styles.glare}></span></a>
                            </div>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                        <img className={styles.item_image}  src={icon_6} alt='илосос'/>
                            <div className={styles.box_info}>
                                <h3 className={styles.item_title}>Монтаж утеплителя</h3>
                                <a className={styles.item_button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>заказать <span className={styles.glare}></span></a>
                            </div>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                        <img className={styles.item_image}  src={icon_7} alt='илосос'/>
                            <div className={styles.box_info}>
                                <h3 className={styles.item_title}>Монтаж изоляции</h3>
                                <a className={styles.item_button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>заказать <span className={styles.glare}></span></a>
                            </div>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                        <img className={styles.item_image}  src={icon_8} alt='илосос'/>
                            <div className={styles.box_info}>
                                <h3 className={styles.item_title}>Монтаж стропильной системы</h3>
                                <a className={styles.item_button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>заказать <span className={styles.glare}></span></a>
                            </div>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                        <img className={styles.item_image}  src={icon_9} alt='илосос'/>
                            <div className={styles.box_info}>
                                <h3 className={styles.item_title}>Монтаж водосточной системы</h3>
                                <a className={styles.item_button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>заказать <span className={styles.glare}></span></a>
                            </div>
                        </motion.li>
                        <motion.li 
                            className={styles.item}
                            variants={cardAnimation}
                            initial='hidden'
                            whileInView='visible'
                            viewport={{amount: 0.01, once: true}}
                            >
                        <img className={styles.item_image}  src={icon_10} alt='илосос'/>
                            <div className={styles.box_info}>
                                <h3 className={styles.item_title}>Ремонт кровли и устранение протечек</h3>
                                <a className={styles.item_button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>заказать <span className={styles.glare}></span></a>
                            </div>
                        </motion.li>
                    </motion.ul>
                </div>
        </motion.section>
        
    )
}

export default Services